import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';


export default function SelectCategoriaPlanoFaturas(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsTipoPlano, setLsTipoPlano] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleCategoriaPlanoFaturas(codigo, nome){
        props.setCdCategoriaPlanoFaturas(codigo)
        props.setDsCategoriaPlanoFaturas(nome)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectCategoriaPlanoFaturas(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderTipoPlano(){
            const {data} = await api_gateway.get('/m1/consultar/fat_plano_tipo');
            if(data.dados.length > 0){
                let objetoTipoPlano = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_plano_tipo}>
                            <div className="campo-select-opcao campo-select-opcao-2" onClick={() => handleCategoriaPlanoFaturas(item.cd_fat_plano_tipo, item.ds_plano_tipo) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_plano_tipo}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsTipoPlano(objetoTipoPlano)
            }else{
                let objetoTipoPlano = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsTipoPlano(objetoTipoPlano)
            }
            setSpinAtivo(false)
        }
        renderTipoPlano()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectCategoriaPlanoFaturas(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsCategoriaPlanoFaturas}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsTipoPlano}
                </ul>
            </div>
        </Form>
    )
}